import { InfoIcon } from 'components/Icons/Icons';
import React from 'react';
import styles from './RenderingWarning.module.scss';
import cls from 'classnames';
import { addDays } from 'date-fns';

type RenderingWarningProps = {
  hatchStartedAt: Date;
};

export const RenderingWarning = ({ hatchStartedAt }: RenderingWarningProps) => {
  const hatchDate = addDays(new Date(hatchStartedAt), 7);
  return (
    <div className={styles.renderingWarning}>
      <div className={styles.warningTitle}>
        <InfoIcon />
        Image to be Generated
      </div>
      <p className={cls('text-60', styles.warningDescription)}>
        Check back in at{' '}
        {hatchDate.toLocaleString('en-US', {
          year: 'numeric',
          month: 'long',
          day: 'numeric',
          hour: 'numeric',
          minute: 'numeric',
        })}{' '}
        to see your Gribble in action
      </p>
    </div>
  );
};
